export const paths = {
    front: {
        commonPoint: '/',
        user: {
            login: 'login',
            reset_password: 'reset_password',
            check_mail: 'check_mail',
            create_new_password: 'create_new_password',

            dashboard: 'dashboard',
            customer: 'customer',
            orders: 'orders',
            banner: 'banner',

            products: 'products',
            product_list: 'product_list',
            brands: 'brands',
            add_new_brand: 'add_new_brand',
            categories: 'categories',
            add_new_category: 'add_new_category',
            sub_categories: 'sub_categories',
            add_sub_categories: 'add_sub_categories',
            add_products: 'add_products',
            add_product_varients: 'add_product_varients',

            notification: 'notification',

            blogs: 'blogs',
            add_blogs: 'add_blogs',
            blog_list: 'blog_list',

            faq: 'faq',
            coupons: 'coupons',
            wallet: 'wallet',
            referrals: 'referrals',
            subscription_plan: 'subscription_plan',
            add_subscription_plan: 'add_subscription_plan',

            combo: 'combo',
            add_combo: 'add_combo',
            add_combo_category: 'add_combo_category',
            combo_sub_category_list: 'combo_sub_category_list',
            add_combo_sub_category: 'add_combo_sub_category',
            combo_product_list: 'combo_product_list',
            deals: 'deals',
            add_new_deal: 'add_new_deal',

            all_about_fitness: 'all_about_fitness',
            gym_guide: 'gym_guide',

            contact_us: 'contact_us',

            offers: 'offers',
            add_new_offer: 'add_new_offer',

            subscribers: 'subscribers',

            shipping: 'shipping',
            shipping_create: 'shipping/create',
            shipping_track: 'shipping/track',
            shipping_ndr: 'shipping/ndr',
            shipping_manifest: 'shipping/manifest',
            shipping_serviceability: 'shipping/serviceability',

            change_password: 'change_password',

            logout: 'logout'
        },

        login: 'login',
    }
}

const apisPathCommon = '/admin'
export const apisPath = {
    commonPoint: '/admin/',
    adminLogin: {
        login: `${apisPathCommon}/login`,
    },

    admin: {

        upload: `/upload`,
        users: `${apisPathCommon}/users`,
        banners: `${apisPathCommon}/banners`,
        brands: `${apisPathCommon}/brands`,
        categories: `${apisPathCommon}/categories`,
        allCategories: `/categories`,
        subcategories: `${apisPathCommon}/subcategories`,
        allSubcategories: `${apisPathCommon}/all-subcategories`,
        blogs: `${apisPathCommon}/blogs`,
        faqs: `${apisPathCommon}/faqs`,
        coupons: `${apisPathCommon}/coupons`,
        plans: `${apisPathCommon}/plans`,

        comboCategories: `${apisPathCommon}/comboCategories`,
        comboSubCategories: `${apisPathCommon}/comboSubCategories`,
        comboProducts: `${apisPathCommon}/combo-products`,

        orders: `${apisPathCommon}/orders`,
        orderAccept: "order/accept",
        orderReject: "order/cancel",
        orderInvoice: "invoiceCharges/",
        products: `${apisPathCommon}/products`,
        stockUpdate: `${apisPathCommon}/stock/update`,

        getReferrals: `${apisPathCommon}/getReferrals`,
        deals: `${apisPathCommon}/deals`,
        product_deals: `${apisPathCommon}/product/deals`,

        dashboard: `${apisPathCommon}/dashboard`,
        notification: `${apisPathCommon}/notification`,
        getNotification: `${apisPathCommon}/notification/schedule`,

        banners: `${apisPathCommon}/banners`,
        subscriptionBanners: `/subscriptionBanner`,

        productAllData: "all/products",
        allProducts: `${apisPathCommon}/all-products`, // New paginated API
        aboutFitness: 'about-fitness',
        gymGuide: 'gym-guide',

        contact_us: 'contacts',
        subscribers: 'subscribe',

        offers: 'offers',

        resetPassword: `${apisPathCommon}/reset-password`

    }
}